import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import ContentIntelligenceWrapper from "@components/layouts/contentIntelligenceWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function ContentIntelligenceHome(): ReactElement {
    return (
        <ContentIntelligenceWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="CMS"
                    domain="ContentIntelligence.com"
                />
            </div>
        </ContentIntelligenceWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
